import { always } from 'ramda';
import { specificationObj as OpenApi3_1Specification } from '@swagger-api/apidom-ns-openapi-3-1';
import CallbackElement from "../../../../elements/Callback.mjs";
/**
 * @public
 */
export const BaseCallbackVisitor = OpenApi3_1Specification.visitors.document.objects.Callback.$visitor;
/**
 * @public
 */
class CallbackVisitor extends BaseCallbackVisitor {
  constructor(options) {
    super(options);
    this.element = new CallbackElement();
    this.specPath = always(['document', 'objects', 'PathItem']);
  }
}
export default CallbackVisitor;